export default (opt = {}) => {
    let editor = opt.editor,
        styleManager = editor.StyleManager;

    styleManager.addType(window.PMW.emails.styles.ID_STEP_BUTTONS, {
        create({props, change}) {
            const el = document.createElement('div');
            el.className = props.type;
            props.inputType = 'number';
            props.component = props.component || editor.getSelected();

            if (typeof props.step === 'undefined') {
                props.step = 1;
            }

            if (typeof props.min === 'undefined') {
                props.min = 0;
            }

            if (typeof props.max === 'undefined') {
                props.max = 100;
            }

            if (typeof props.units === 'undefined') {
                props.units = '';
            }

            el.innerHTML = getStepButtonsHTML(props);
            const desktopEl = el.querySelector('.js-container-desktop'),
                tabletEl = el.querySelector('.js-container-tablet'),
                mobileEl = el.querySelector('.js-container-mobile');

            function attachHandlers(el) {
                const inputTextEl = el.querySelector('.js-step-input');
                setStepButtonsHandlers.call(this, inputTextEl, props, change, el);
                setStepButtonsInitialValue(el, props);
            }

            attachHandlers(desktopEl);
            if (props.isResponsive) {
                const propertyName = props.property;
                props.property = window.PMW.emails.MOBILE_CSS_PROP_PREFIX + propertyName;
                attachHandlers(mobileEl);

                props.property = window.PMW.emails.TABLET_CSS_PROP_PREFIX + propertyName;
                attachHandlers(tabletEl);
            }

            return el;
        },

        emit({props}, {el, propertyName, value}) {
            let property = props.property;

            if (typeof propertyName === 'string') {
                property = propertyName;
            }

            if (typeof property === 'undefined') {
                return;
            }

            if (typeof props.units === 'undefined') {
                props.units = 'px';
            }

            const valueString = value + props.units,
                tabletCssPropRegex = new RegExp(`^${window.PMW.emails.TABLET_CSS_PROP_PREFIX}`),
                mobileCssPropRegex = new RegExp(`^${window.PMW.emails.MOBILE_CSS_PROP_PREFIX}`),
                isTabletPropUpdate = props.isResponsive && tabletCssPropRegex.test(property),
                isMobilePropUpdate = props.isResponsive && mobileCssPropRegex.test(property);

            handleCustomProperty(property, value);
            if (isTabletPropUpdate) {
                editor.runCommand(window.PMW.emails.commands.SET_DEVICE_MEDIA_QUERY, {
                    property,
                    value: valueString,
                    id: props.component.ccid,
                    deviceID: window.PMW.emails.DEVICE_TABLET,
                    cssPrefix: window.PMW.emails.TABLET_CSS_PROP_PREFIX,
                });

            } else if (isMobilePropUpdate) {
                editor.runCommand(window.PMW.emails.commands.SET_DEVICE_MEDIA_QUERY, {
                    property,
                    value: valueString,
                    id: props.component.ccid,
                    deviceID: window.PMW.emails.DEVICE_MOBILE,
                    cssPrefix: window.PMW.emails.MOBILE_CSS_PROP_PREFIX,
                });
            }

            editor.runCommand(window.PMW.emails.commands.SET_COMPONENT_STYLE, {property, value: valueString, component: props.component});
            updateStepButtonsState(el);
        },
    });

    /**
     * @param {string} property
     * @param {*} value
     */
    function handleCustomProperty(property, value) {
        if (property === 'pmw-columns') {
            editor.runCommand(window.PMW.emails.commands.UPDATE_TABLE_COLUMNS, {sliderVal: value});
        }

        if (property === 'pmw-rows') {
            editor.runCommand(window.PMW.emails.commands.UPDATE_TABLE_ROWS, {sliderVal: value});
        }
    }

    function setStepButtonsHandlers(inputEl, props, change, el) {
        const propertyName = props.property,
            stepDownBtn = el.querySelector('.js-step-down-btn'),
            stepUpBtn = el.querySelector('.js-step-up-btn'),
            inputBtnContainer = el.querySelector('.pmw-input-btns-container');

        function handleBtnClick(deltaValue) {
            let inputEl = el.querySelector('.js-step-input'),
                currVal = parseInt(inputEl.value);
            inputEl.value = currVal + deltaValue;
            change({el, propertyName, value: currVal + deltaValue});
        }

        stepDownBtn.addEventListener('click', _ => handleBtnClick(-1));
        stepUpBtn.addEventListener('click', _ => handleBtnClick(1));

        inputEl.addEventListener('focus', _ => {
            inputBtnContainer.classList.add('-selected');
        });

        inputEl.addEventListener('blur', _ => {
            inputBtnContainer.classList.remove('-selected');
        });

        inputEl.addEventListener('change', _ => {
            const value = getValidatedPropertyValue(inputEl);
            change({el, propertyName, value});
        });
    }

    function getValidatedPropertyValue(el) {
        let t = $(el),
            v = parseInt(t.val()),
            min = parseInt(t.attr('min')),
            max = parseInt(t.attr('max'));

        if (v < min) {
            t.val(min);
            return min;
        } else if (v > max) {
            t.val(max);
            return max;
        }

        return v;
    }

    function getStepButtonsHTML(props) {
        let desktopContainer = '',
            tabletContainer = '',
            mobileContainer = '',
            propertyInputSelectors = '',
            desktopContainerClassName = 'js-container-desktop',
            tabletContainerClassName = 'hidden-device-desktop hidden-device-mobile js-container-tablet',
            mobileContainerClassName = 'hidden-device-desktop hidden-device-tablet js-container-mobile';

        desktopContainerClassName = (props.isResponsive ? 'hidden-device-tablet hidden-device-mobile' : '') + desktopContainerClassName;

        function getStepButtonsContainerMarkup(props, responsiveTag = '', className = '') {
            return `<div class="pmw-email-editor-step-buttons-container ${className}">
                <div class="pmw-email-editor-step-buttons-label-container">
                    <span class="style-manager-label"> 
                        ${(responsiveTag ? `<span class="highlight-tag body-xxs-bold -rounded">${responsiveTag}</span>` : '') + props.propertyLabel}
                    </span>
                    <div class="pmw-input-btns-container">
                        <button class="btn step-btn -down icon-minus size-icon-16 js-step-down-btn"></button>
                        <div class="pmw-input-container">
                            <input data-units="${props.units}" class="pmw-step-buttons-text content-body body-xs js-step-input js-emails-${props.property}-input" type="number" min="${props.min}" max="${props.max}" step="${props.step}"/>
                            <span class="pmw-email-editor-step-buttons-units ${props.units ? '' : '_hidden'}">${props.units}</span>
                        </div>
                        <button class="btn step-btn -up icon-plus size-icon-16 js-step-up-btn"></button>
                    </div>
                </div>
                ${propertyInputSelectors} 
            </div>`;
        }

        desktopContainer = getStepButtonsContainerMarkup(props, false, desktopContainerClassName);

        if (props.isResponsive) {
            const propertyName = props.property;
            props.property = window.PMW.emails.MOBILE_CSS_PROP_PREFIX + propertyName;
            mobileContainer = getStepButtonsContainerMarkup(props, 'Mobile', mobileContainerClassName);
            props.property = window.PMW.emails.TABLET_CSS_PROP_PREFIX + propertyName;
            tabletContainer = getStepButtonsContainerMarkup(props, 'Tablet', tabletContainerClassName);
            props.property = propertyName;
        }

        return `<div class="pmw-email-editor-step-buttons-containers">
            ${desktopContainer}
            ${mobileContainer}
            ${tabletContainer}
        </div>`;
    }

    /**
     * @param {HTMLElement} el main element containing buttons and input box
     */
    function updateStepButtonsState(el) {
        const stepDownBtn = el.querySelector('.js-step-down-btn'),
            stepUpBtn = el.querySelector('.js-step-up-btn'),
            inputEl = el.querySelector('.js-step-input'),
            min = parseInt(inputEl.getAttribute('min')),
            max = parseInt(inputEl.getAttribute('max')),
            val = parseInt(inputEl.value);

        if (val <= min) {
            stepDownBtn.setAttribute('disabled', true);
        } else if (val >= max) {
            stepUpBtn.setAttribute('disabled', true);
        } else {
            stepDownBtn.removeAttribute('disabled');
            stepUpBtn.removeAttribute('disabled');
        }
    }

    /**
     * @param {HTMLElement} el
     * @param {object} props
     */
    function setStepButtonsInitialValue(el, props) {
        let value = opt.editor.runCommand(window.PMW.emails.commands.GET_COMPONENT_STYLE, {component: props.component, property: props.property}),
            inputEl = el.querySelector('.js-step-input'),
            parsedValue = value !== null ? parseInt(value, 10) : parseInt(props.defaults, 10);

        parsedValue = isNaN(parsedValue) ? parseInt(props.defaults, 10) : parsedValue;
        inputEl.value = parsedValue;

        if (!isNaN(parsedValue)) {
            el.querySelector('.js-step-input').value = parsedValue;
            updateStepButtonsState(el);
        }
    }
}